import React from 'react';
import { FiSettings, FiUser, FiSliders, FiHome, FiMapPin, FiLock, FiFileText, FiCreditCard, FiPackage, FiUsers, FiPercent, FiDollarSign, FiGlobe, FiArchive, FiTrendingUp, FiTrendingDown } from 'react-icons/fi';
import './SettingsAppearance.css';

const icons = {
    MyAccount: FiUser, GeneralSettings: FiSliders, MyCompany: FiHome,
    MyBranches: FiMapPin, ChangePassword: FiLock, InvoiceSettings: FiFileText,
    QuoteSettings: FiFileText, PaymentMethod: FiCreditCard, ProductServiceSettings: FiPackage,
    CustomerSettings: FiUsers, VatSettings: FiPercent, CurrencySettings: FiDollarSign,
    LanguagesSetting: FiGlobe, Treasury: FiArchive, account: FiCreditCard,
    incomes: FiTrendingUp, expenses: FiTrendingDown, PurchasesInvoiceSettings: FiFileText,
    PurchasesQuoteSettings: FiFileText, PurchasesPaymentMethod: FiCreditCard
};

export function SettingsHeading({ title }) {
    return <header className="settings-page-heading">
        <span className="settings-page-heading-icon"><FiSettings size={18} /></span>
        <h1>{title}</h1>
    </header>;
}

export default function SettingsNavigation({ items, activeMenu, onSelect, label }) {
    return <nav className="settings-menu" aria-label={label}>
        <div className="settings-menu-label"><FiSettings size={15} /><span>{label}</span></div>
        <div className="settings-menu-list">
            {items.map(item => {
                const Icon = icons[item.id] || FiSettings;
                return <button key={item.id} type="button"
                    className={'settings-menu-item' + (activeMenu === item.id ? ' is-active' : '')}
                    aria-current={activeMenu === item.id ? 'page' : undefined}
                    disabled={item.disabled} title={item.label}
                    onClick={() => onSelect(item)}>
                    <Icon size={17} aria-hidden="true" />
                    <span className="settings-menu-text">{item.label}</span>
                    {item.badge && <span className="settings-menu-badge">{item.badge}</span>}
                </button>;
            })}
        </div>
    </nav>;
}
